import React from 'react';
import currency from 'currency.js';
import type { BundleItem } from 'flow-types';
import { Trans } from 'react-i18next';
import { itemTotalPrice, Price } from '@vmos2/price';

type Props = {
	isTakeAway: boolean,
	hidePriceInfo?: boolean,
	items: BundleItem[],
	Component: React.Component,
};

export const PackagingInfo = ({ items, isTakeAway, hidePriceInfo, Component, ...props }: Props) => {
	const bundleBase = getBundleBase(items);
	if (!bundleBase?.nutritionalInfo) return null;
	const servingSize = bundleBase.nutritionalInfo?.nutrition?.servingSize || 1;
	const { measurementUnits } = bundleBase;
	return (
		<Component {...props}>
			<Trans
				ns="bundles.packagingInfo"
				i18nKey="size"
				context={measurementUnits.measurement_type}
				values={{ servingSize, unit: measurementUnits.symbol }}
			/>
			{
				!hidePriceInfo &&
				<Trans
					ns="bundles.packagingInfo"
					i18nKey="price_per"
					context={measurementUnits.measurement_type}
					values={{
						price: currency(itemTotalPrice(bundleBase, isTakeAway))
							.multiply(proportionToStandardMeasurementUnit(measurementUnits.unit))
							.divide(servingSize)
							.value,
						unit: measurementUnits.symbol,
					}}
					components={[<Price />]}
				/>
			}
		</Component>
	);
};

const getBundleBase = (items: BundleItem[]) => {
	return items.find(({ type }) => type === 'BUNDLE_BASE');
};

const proportionToStandardMeasurementUnit = (unit) => {
	return ['metric_milliliter', 'gram'].includes(unit) ? 1000 : 1;
};
